import React from "react";
import { connect } from "react-redux";
import Card from "components/card";
import ButtonWithConfirm from "components/button/buttonwithconfirm";
import {
  doClassParticipantEnrollNow
} from '../../redux/trainingclass/trainingClassState';

const CourseCard = ({ 
  recordData,
  enrollParticipant,
}) => {


  const onClickEnrollParticipantNow = () => {
    if (!recordData?.tcl_id) return;

    enrollParticipant({
      classeId: recordData.tcl_id,
    });
  };

  return (
    <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200 dark:border-zinc-700 hover:shadow-lg transition-all dark-mode-card">
      <div className="p-4 sm:p-5">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between mb-2">
          <h4 className="flex-1 text-sm font-semibold line-clamp-2 dark:text-white">{recordData?.tcl_title}</h4>
          <span
            className={`self-start sm:self-auto shrink-0 inline-flex status-indicator ${
              recordData?.tcl_difficulty_name
                ?.toLowerCase()
                .replace(/\s+/g, "-")
            }`}
          >
            {recordData?.tcl_difficulty_name}
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-1 text-xs text-slate-700 mb-4 dark:text-slate-100">
          <span>{recordData?.course_cat_name}</span>
          <span>•</span>
          <span>{recordData?.tcl_duration}</span>
        </div>
        <ButtonWithConfirm
          className="access-button btn-enroll-now w-full !h-10 sm:!h-9"
          confirmationTitle="Enroll Now"
          confirmHandler={onClickEnrollParticipantNow}
        >
          Enroll Now
        </ButtonWithConfirm>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  enrollParticipant: (data) => dispatch(doClassParticipantEnrollNow(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CourseCard);

